import { useState } from 'react'

import { Button, Dialog, DialogTrigger, Modal, ModalOverlay } from 'react-aria-components'

import { clearState } from '../../../local_storage/index.js'

const buttonStyle = 'p-3 border-2 bg-green-200 outline-black border-solid border rounded-sm'

const credits = [
  { role: 'Created, written and designed by', names: ['Smith Geursen'] },
  { role: 'Programming by', names: ['Piet Geursen'] },
  { role: 'Illustrations by', names: ['Ari Syahrazad', 'Joseba Morales', 'Valeriia Lugai', 'Z. Costa from Line Art Studios'] }
]

export default function Settings () {
  const [view, setView] = useState('menu')

  const restartGame = () => {
    // Wipe the persisted game state and reload. On reload `loadState()` returns
    // undefined, so every slice falls back to its initial state and the router
    // starts again from the splash screen — a clean start from scratch.
    clearState()
    window.location.reload()
  }

  return (
    <DialogTrigger onOpenChange={() => setView('menu')}>
      <Button
        aria-label='Menu'
        className='fixed top-2 right-2 z-[9999] w-10 h-10 flex items-center justify-center bg-white border-2 border-solid border-black rounded-full text-xl'
      >
        ⚙️
      </Button>

      <ModalOverlay isDismissable className='fixed inset-0 z-[10000] flex items-center justify-center backdrop-blur-xs'>
        <Modal className='bg-white p-6 border-2 border-solid border-black rounded-sm font-mono max-w-sm w-11/12'>
          <Dialog className='outline-none'>
            {({ close }) => (
              <>
                {view === 'menu' && (
                  <>
                    <h1 className='text-2xl mb-4'>Menu</h1>
                    <button onClick={() => setView('confirmingRestart')} className={buttonStyle}>
                      Restart game
                    </button>
                    <button onClick={() => setView('credits')} className={`${buttonStyle} ml-2`}>
                      Credits
                    </button>
                  </>
                )}

                {view === 'confirmingRestart' && (
                  <>
                    <h1 className='text-2xl mb-4'>Menu</h1>
                    <p className='mb-3'>Restart from scratch? This will erase all of your progress.</p>
                    <button onClick={restartGame} className={`${buttonStyle} bg-red-300`}>
                      Yes, restart
                    </button>
                    <button onClick={() => setView('menu')} className={`${buttonStyle} ml-2`}>
                      Cancel
                    </button>
                  </>
                )}

                {view === 'credits' && (
                  <>
                    <h1 className='text-2xl mb-4'>Credits</h1>
                    {credits.map(({ role, names }) => (
                      <div key={role} className='mb-3'>
                        <p className='text-sm'>{role}</p>
                        {names.map((name) => (
                          <p key={name} className='font-bold'>{name}</p>
                        ))}
                      </div>
                    ))}
                    <button onClick={() => setView('menu')} className={buttonStyle}>Back</button>
                  </>
                )}

                <div className='mt-6'>
                  <button onClick={close} className={buttonStyle}>Close</button>
                </div>
              </>
            )}
          </Dialog>
        </Modal>
      </ModalOverlay>
    </DialogTrigger>
  )
}
